document.addEventListener('DOMContentLoaded', () => {
    let currentIndex = 0;

    function showSlide(carousel, slides, index) {
      // Activate correct slide
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      // Reset aria-current on old thumbnail
      const prevThumb = carousel.querySelector(
        `li.thumbnail-list__item[data-media-position="${currentIndex + 1}"] button`
      );
      if (prevThumb) prevThumb.removeAttribute('aria-current');

      // Update index
      currentIndex = index;

      // Set aria-current on new thumbnail
      const activeThumb = carousel.querySelector(
        `li.thumbnail-list__item[data-media-position="${currentIndex + 1}"] button`
      );
      if (activeThumb) activeThumb.setAttribute('aria-current', 'true');
    }

    // Functions for prev/next
    window.mlvCarouselNext = function (btn) {
      const carousel = btn.closest('[id^="MediaGallery-"]');
      if (!carousel) return;

      const slides = carousel.querySelectorAll('li.product__media-item');
      if (!slides.length) return;

      const newIndex = (currentIndex + 1) % slides.length;
      showSlide(carousel, slides, newIndex);
    };

    window.mlvCarouselPrev = function (btn) {
      const carousel = btn.closest('[id^="MediaGallery-"]');
      if (!carousel) return;

      const slides = carousel.querySelectorAll('li.product__media-item');
      if (!slides.length) return;

      const newIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(carousel, slides, newIndex);
    };

    // Init first carousel if present
    const firstCarousel = document.querySelector('[id^="MediaGallery-"]');
    if (firstCarousel) {
      const slides = firstCarousel.querySelectorAll('li.product__media-item');
      if (slides.length) showSlide(firstCarousel, slides, 0);
    }
  });